import { Actions } from './actions';
import { Part } from './part';
import { VehicleState } from './vehicleState';
import { Dictionary } from 'lodash';

export class VehicleMaintenance {
    public vin: string;
    public parts: Part[];
    public vehicleScheduleId: string;
    public vehicleScheduleName: string;
    public completionDate: Date;
    public date: Dictionary<Date>;
    public action: Actions;
    public state: Dictionary<string>;
    public updatedBy: string;
    public createdBy: string;
    public notes: string;
    public vehicleState: VehicleState;
    public id: string;
    public createDateTimeUtc: Date;
    public updateDateTimeUtc: Date;
    public hours: number;
    constructor() {
        this.vin = '';
        this.parts = new Array<Part>();
        this.vehicleScheduleId = null;
        this.vehicleScheduleName = '';
        this.completionDate = null;
        this.date = {};
        this.action = Actions.Null;
        this.state = {};
        this.updatedBy = null;
        this.createdBy = null;
        this.notes = null;
        this.hours = 0;
        this.vehicleState = new VehicleState();
    }
}
